export const dateToUtc = (date) => {
    return new Date(
        date.getUTCFullYear(),
        date.getUTCMonth(),
        date.getUTCDate(),
        date.getUTCHours(),
        date.getUTCMinutes(),
        date.getUTCSeconds(),
    )
}

export const isDropWeek = (date) => {
    const dropWeekStartDay = 19
    const dropWeekEndDay = 25
    const dropWeekMonth = 8
    const dropWeekYear = 2022
    return (
        date.getDate() >= dropWeekStartDay &&
        date.getDate() <= dropWeekEndDay &&
        date.getMonth() === dropWeekMonth &&
        date.getFullYear() === dropWeekYear
    )
}
